var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.headShow)?_c('headers'):_vm._e(),_vm._v(" "),_c('router-view'),_vm._v(" "),(_vm.$route.meta.active != 'hotList' && _vm.$route.meta.active != 'city')?_c('footers'):_vm._e(),_vm._v(" "),_c('el-backtop')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd2f7a34","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 